const reviews = [
  {
    id: 1,
    name: "Carolina",
    job: "Chile - Airbnb",
    image:
      "https://a0.muscache.com/im/pictures/user/5dbb2b08-f0af-4632-b8f8-530515631683.jpg?aki_policy=profile_large",
    text:
      "Excelente comunicación y flexibilidad. Transporte cerca , todo limpio y ordenado. 100% recomendado",
  },
  {
    id: 2,
    name: "Alvaro",
    job: "Chile - Airbnb",
    image:
      "https://a0.muscache.com/im/pictures/user/4b6202fc-54a1-4de7-a680-752d711594ca.jpg?aki_policy=profile_large",
    text:
      "Todo muy bien, el espacio es cómodo y cuenta con todo los servicios básicos que se requieren",
  },
  {
    id: 3,
    name: "Geoffrey",
    job: "Francia - Airbnb",
    image:
      "https://a0.muscache.com/im/pictures/user/ca0e6081-cf50-4cb6-888a-9a3d8eedd567.jpg?aki_policy=profile_large",
    text:
      "Un appartement parfait, calme, propre et très agréable ! Il y a même une petite cuisine ! L'acceuil est super et il y a aussi un livret qui indiquent les lieux à visiter ! Très bien situé, proche du centre ville !",
  },
  {
    id: 4,
    name: "Felipe",
    job: "Chile - Airbnb",
    image:
      "https://a0.muscache.com/im/pictures/user/c3257404-5588-4ed6-8120-7263f25bc053.jpg?aki_policy=profile_large",
    text: "Buen lugar, excelente preocupación del anfitrión...",
  },
]

export default reviews
